import React, { useEffect, useState } from 'react';
import M from 'materialize-css';
import { Link, Redirect } from 'react-router-dom';
import ModalCompanyDialog from './ModalCompanyDialog';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { connect } from 'react-redux';
import { badgesType } from '../../constants/constants';

const refModal = React.createRef();

function RemovePynsByCompany(props) {
  const [uidCompany, setUidCompany] = useState('');
  const [company, setCompany] = useState(null);
  const [country, setCountry] = useState('');
  const [type, setType] = useState('');
  const [pyns, setPyns] = useState([]);
  const [currentCompanies, setCurrentCompanies] = useState([]);
  const [showProcessText, setShowProcessText] = useState(false);
  const [validTypeBadge, setValidTypeBadge] = useState(false);
  const [validPyns, setValidPyns] = useState(false);
  const [validCountry, setValidCountry] = useState(false);
  const [validCompany, setValidCompany] = useState(false);
  const { firestore, companies, auth } = props;

  useEffect(() => M.AutoInit(), []);

  const openCompanyDialog = () => {
    const modal = M.Modal.getInstance(refModal.current);
    modal.open();
  };

  const search = (searchTerm) => {
    filterCompanies(country, searchTerm);
  };

  const updateCountry = (country) => {
    setCountry(country);
    filterCompanies(country, '');
  };

  const filterCompanies = (country, companyName) => {
    if (!companies) return;
    let filteredCompanies = companies.filter((company) => {
      return company.countryCode === country && (companyName !== '' ? company.companyName.toLowerCase().includes(companyName.toLowerCase()) : true);
    });
    setCurrentCompanies(filteredCompanies);
  };

  const getPynsByCompany = () => {
    if (company) {
      firestore
        .collection('pyns')
        .where('d.uidCompany', '==', uidCompany)
        .where('d.country', '==', country)
        .where('d.type', '==', type)
        .get()
        .then((querySnapshot) => {
          const pyns = [];
          querySnapshot.forEach((doc) => {
            pyns.push({ id: doc.id, ...doc.data() });
          });
          setPyns(pyns);
        })
        .catch((e) => {
          console.log('Error get pyns', e.message());
        });
    } else {
      console.log('NO VALID');
    }
  };

  const validFields = () => {
    const validPyns = pyns.length > 0;
    const validCountry = country != null && country.length > 0;
    const validTypeBadge = type != null && type.length > 0;
    const validCompany = company != null;
    setValidPyns(validPyns);
    setValidCountry(validCountry);
    setValidTypeBadge(validTypeBadge);
    setValidCompany(validCompany);

    return validPyns && validCountry && validTypeBadge && validCompany;
  };

  const removePyns = async () => {
    if (validFields() && !showProcessText) {
      try {
        if (pyns && pyns.length > 0) {
          const promises = [];
          let query = firestore.collection('pyns');
          setShowProcessText(true);
          pyns.forEach((pyn) => {
            promises.push(query.doc(pyn.id).delete());
          });
          try {
            await Promise.all(promises);
            setShowProcessText(false);
            setPyns([]);
          } catch (e) {
            console.log(e.message());
          }
        }
      } catch (e) {
        console.log(e.message);
      }
    }
  };

  const renderTypeSelect = () => {
    const types = [];
    for (const key in badgesType) types.push(badgesType[key]);
    return (
      <div className="row">
        <div className="input-field col s12">
          <select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="">Select a type</option>
            {types.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
          <label>Type</label>
        </div>
      </div>
    );
  };

  const renderSelectCountry = () => {
    return (
      <div className="row">
        <div className="input-field col s12">
          <select
            className="icons"
            value={country}
            onChange={(e) => {
              updateCountry(e.target.value);
            }}>
            <option value="" disabled>
              Select your Country
            </option>
            <option data-icon="images/ca.svg" value="CA">
              Canada
            </option>
            <option data-icon="images/us.svg" value="US">
              United States
            </option>
            <option data-icon="images/bo.svg" value="BO">
              Bolivia
            </option>
          </select>
          <label>Country</label>
        </div>
      </div>
    );
  };

  if (!auth.uid) {
    return <Redirect to="/signin" />;
  }
  
  return (
    <div className="container">
      <div className="title-section">Remove Pyns by company</div>
      {showProcessText ? <h3>Processing...</h3> : <div />}
      <div className="row">
        <div className="col s6 card-content">
          {renderTypeSelect()}
          {renderSelectCountry()}
          <div className="row">
            <div className="input-field">
              <div className="col s6">
                <label htmlFor="company_uid">Company UID</label>
                {company ? <p>{company.companyName}</p> : <div />}
                <input id="company_uid" type="text" name="uidCompany" value={uidCompany} onChange={(e) => setUidCompany(e.target.value)} />
              </div>
              <div className="col s6">
                <Link to="#" onClick={() => openCompanyDialog()}>
                  Select company
                </Link>
              </div>
            </div>
          </div>
          <div>
            {!validTypeBadge ? <p className="red-text"> Select Type</p> : <div />}
            {!validCountry ? <p className="red-text">Select Country</p> : <div />}
            {!validCompany ? <p className="red-text">Select Company</p> : <div />}
            {!validPyns ? <p className="red-text">There are no pyns</p> : <div />}
            <button className="waves-effect waves-light btn btn-large" onClick={removePyns}>
              Remove Pyns
            </button>
          </div>
        </div>

        <div className="col s6 card-content">
          <div>
            <button className="waves-effect waves-light btn btn-large" onClick={getPynsByCompany}>
              Get Pyns
            </button>
            <p>Pyns</p>
          </div>
          <div className="placeSearchContainer">
            {pyns && pyns.length > 0 ? (
              pyns.map((p) => {
                return (
                  <div className="card" key={p.id}>
                    <div className="card-content">
                      <p>Id: {p.id}</p>
                      <p>State: {p.d.state}</p>
                      <p>Country: {p.d.country}</p>
                      <p>address: {p.d.address}</p>
                    </div>
                  </div>
                );
              })
            ) : (
              <div />
            )}
          </div>
        </div>
      </div>
      <ModalCompanyDialog refModal={refModal} search={search} currentCompanies={currentCompanies} setUidCompany={setUidCompany} setCompany={setCompany} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    companies: state.firestore.ordered.companies,
    auth: state.firebase.auth,
  };
};

export default compose(firestoreConnect([{ collection: 'companies', orderBy: ['companyName', 'asc'] }]), connect(mapStateToProps))(RemovePynsByCompany);
